import roles from "@/roles";
export default [
  {
    icon: "account_box",
    title: "ParcelShieldUsers",
    roles: [roles.ADMIN, roles.USERS_ADMIN],
    children: [
      {
        icon: "account_box",
        router: true,
        title: "ParcelShield Users",
        roles: [roles.ADMIN, roles.USERS_ADMIN],
        to: "ParcelShieldUsers"
      }
    ]
  }
];
